import { $, w } from './constants';

export function calcPPR() {

	const incomeEl = $('.calc_ppr_income_JS');
	const percEl = $('.calc_ppr_perc_JS');
	const btn = $('.calc_ppr_btn_JS');

	const yearlyEl = $('.calc_ppr_yearly_JS');
	const saveEl = $('.calc_ppr_save_JS');
	const maxEl = $('.calc_ppr_max_JS');
	const rateEl = $('.calc_ppr_rate_JS');
	const deductEl = $('.calc_ppr_deduct_JS');

	const isrTable = [
		{ lower: 0,        upper: 8952,     fixed: 0,       rate: 1.92 },
		{ lower: 8953,     upper: 75985,    fixed: 172,     rate: 6.40 },
		{ lower: 75985,    upper: 133536,   fixed: 4462,    rate: 10.88 },
		{ lower: 133536,   upper: 155230,   fixed: 10724,   rate: 16.00 },
		{ lower: 155230,   upper: 185853,   fixed: 14195,   rate: 17.92 },
		{ lower: 185853,   upper: 374838,   fixed: 19682,   rate: 21.36 },
		{ lower: 374838,   upper: 590796,   fixed: 60049,   rate: 23.52 },
		{ lower: 590796,   upper: 1127927,  fixed: 110843,  rate: 30.00 },
		{ lower: 1127927,  upper: 1503902,  fixed: 271982,  rate: 32.00 },
		{ lower: 1503902,  upper: 4511707,  fixed: 392294,  rate: 34.00 },
		{ lower: 4511707,  upper: Infinity, fixed: 1414948, rate: 35.00 }
	];

	function calcISR(annualIncome) {
		const row = isrTable.find(r => annualIncome >= r.lower && annualIncome <= r.upper);
		if (!row) return 0;

		const excess = annualIncome - row.lower;
		const marginal = excess * (row.rate / 100);
		return row.fixed + marginal;
	}

	function run() {
		let rawIncome = incomeEl.val().replace(/,/g, '');
		const isEmpty = rawIncome === '';
		const isAllZeros = /^0+$/.test(rawIncome);
		const isZero = rawIncome === '0';

		if (isEmpty || isAllZeros || isZero) {
			incomeEl.addClass('error');
			return;
		}

		let income = parseFloat(rawIncome);
		if (isNaN(income) || income <= 0) {
			incomeEl.addClass('error');
			return;
		}

		incomeEl.removeClass('error');

		let perc = parseFloat(percEl.val());
		if (isNaN(perc) || perc < 0) perc = 0;
		if (perc > 10) perc = 10;
		percEl.val(perc);

		const yearly = income * 12;
		const save = yearly * (perc / 100);

		const rawDeduction = yearly * 0.10;
		const deductionCap = 206368;
		const deduction = Math.min(rawDeduction, deductionCap);

		const isrNormal = calcISR(yearly);
		const taxableWithPPR = yearly - deduction;
		const isrWithPPR = calcISR(taxableWithPPR);

		const refund = isrNormal - isrWithPPR;
		const effectiveRate = yearly > 0 ? (isrNormal / yearly) * 100 : 0;

		yearlyEl.text(`$${yearly.toLocaleString('es-MX')} MXN`);
		saveEl.text(`$${save.toLocaleString('es-MX')} MXN`);
		maxEl.text(`$${deduction.toLocaleString('es-MX')} MXN`);
		rateEl.text(`${effectiveRate.toFixed(0)}%`);
		deductEl.text(`$${Math.round(refund).toLocaleString('es-MX')} MXN`);
	}

	btn.on('click', run);
	run();
}

function formatInputWithCaret(el) {
	const rawBefore = el.value;
	const caretPosBefore = el.selectionStart;

	let digitsBeforeCaret = 0;
	for (let i = 0, count = 0; i < caretPosBefore; i++) {
		if (/\d/.test(rawBefore[i])) count++;
		digitsBeforeCaret = count;
	}

	let raw = rawBefore.replace(/[^\d]/g, '');

	if (raw === '') {
		el.value = '';
		setTimeout(() => el.setSelectionRange(0, 0), 0);
		return;
	}

	const match = raw.match(/^(0*)(\d*)$/);
	const leadingZeros = match ? match[1] : '';
	let digits = match ? match[2] : raw;

	let formattedDigits = digits.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
	const formatted = leadingZeros + formattedDigits;

	el.value = formatted;

	let newCaretPos = 0;
	let digitsSeen = 0;
	while (digitsSeen < digitsBeforeCaret && newCaretPos < formatted.length) {
		if (/\d/.test(formatted[newCaretPos])) digitsSeen++;
		newCaretPos++;
	}

	setTimeout(() => {
		el.setSelectionRange(newCaretPos, newCaretPos);
	}, 0);
}

const incomeInput = document.querySelector('.calc_ppr_income_JS');
if (incomeInput) {
	incomeInput.addEventListener('input', () => {
		formatInputWithCaret(incomeInput);

		const raw = incomeInput.value.replace(/,/g, '');
		const isEmpty = raw === '';
		const isZero = /^0+$/.test(raw);

		if (isEmpty || isZero) {
			incomeInput.classList.add('error');
		} else {
			incomeInput.classList.remove('error');
		}
	});
}
